import { lineSeparatorStyledBuild } from '../commonStyles';
import { LineSeparatorLineVariantType } from '../variants';
export const getDecorativeHorizontalStyles = (FOUNDATIONS, FONT) => {
    return {
        [LineSeparatorLineVariantType.DECORATIVE_HORIZONTAL]: {
            buildLineStyles: lineSeparatorStyledBuild({
                border_color: FOUNDATIONS.color_comp_tableslist_lineseparator_decorative_border,
                border_weight: FOUNDATIONS.size_25,
            }),
        },
    };
};
//# sourceMappingURL=decorativeHorizontal.js.map